const createCAdESFromBase64 = async function(base64ToSign, storageType) {
    return new Promise(function(resolve, reject) {
        const webSocket = new WebSocket('wss://127.0.0.1:13579/');

        webSocket.onopen = function(event) {
            const args = {
                data: base64ToSign,
                locale: localStorage.getItem("locale"),
                format: "cms",
                allowedStorages: [storageType],
                signingParams: {
                    decode: false,
                    encapsulate: false,
                    digested: false,
                    tsaProfile: null,
                },
                signerParams: {
                    extKeyUsageOids: [
                        "1.3.6.1.5.5.7.3.4",
                    ],
                    iin: "",
                    bin: "",
                    serialNumber: "",
                    chain: null,
                },
            };

            const payload = {
                module: "kz.gov.pki.knca.basics",
                method: "sign", // options.signMethod,
                args,
            };

            webSocket.send(JSON.stringify(payload));
        };

        webSocket.onclose = function(event) {
            if (event.wasClean) {
                //console.log('connection has been closed');
            } else {
                //console.log('Connection error');
                resolve('notConnected');
            }
            // console.log(event);
            //console.log('Code: ' + event.code + ' Reason: ' + event.reason);
        };

        var callback = async result => {
            if (result['code'] === '500') {
                if (result['message'] === 'storage.empty') {
                    resolve(result['message']);
                }
                resolve(null);
            } else if (result['code'] === '200') {
                var res = result['responseObject'];
                resolve(res);
            }
        };

        webSocket.onmessage = function(event) {

            const result = JSON.parse(event.data);
            if (result && result["status"]) {
                // if (result["body"]["result"]) {
                //     const res = result["body"]["result"];
                //     resolve({ result: res[0] });
                // } else
                //     resolve({
                //         result: false,
                //         message: "NCALayer: action.canceled",
                //     });

                //console.log('result["body"]["result"]', result["body"]["result"]);

                var rw = {
                    code: result["body"]["result"]? "200" : "500",
                    message: result["body"]["result"] ? null : "action.canceled",
                    responseObject: result["body"]["result"][0].replace("-----BEGIN CMS-----", "").replace("-----END CMS-----", ""),
                    getResult: function() {
                        return this.result;
                    },
                    getMessage: function() {
                        return this.message;
                    },
                    getResponseObject: function() {
                        return this.responseObject;
                    },
                    getCode: function() {
                        return this.code;
                    }
                };

                //console.log('rw', rw)

                if (callback != null) {
                    callback(rw);
                }

                //webSocket.close();
            }


        };
    });
};

export { createCAdESFromBase64 };
